export const ANAM_PERSONA_ID = "";
export const ANAM_LLM_ID = "";
export const ANAM_SYSTEM_PROMPT = "";

export const ANAM_LLM_CUSTOMER_CLIENT_V1 = "CUSTOMER_CLIENT_V1";
export const ANAM_INLINE_NAME = "AVA Trainer Test";
export const ANAM_AVATAR_ID = "a9220480-1ff5-41d0-b8a6-be77b668f900";
export const ANAM_VOICE_ID = "22d37759-ff21-4f32-8798-cc520a6a2f44";
export const ANAM_VOICE_PROVIDER = "cartesia";
export const ANAM_CARTESIA_VOICE_GENERATION_OPTIONS = {
  emotion: "angry", // neutral, calm, angry, content, sad, scared
  speed: 0.9,
};

export const ANAM_TOKEN_EMPTY_RESPONSE_ERROR_CODE = "ANAM_TOKEN_EMPTY_RESPONSE";
export const ANAM_TOKEN_REQUEST_ERROR_CODE = "ANAM_TOKEN_REQUEST_ERROR";

export class AnamTokenError extends Error {
  constructor(code, message, details = {}) {
    super(message);
    this.name = "AnamTokenError";
    this.code = code;
    this.details = details;
  }
}
